<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item
          :label="$t('devices.inventory.Inventory Name')"
          prop="name"
        >
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          :label="$t('devices.inventory.Select Store')"
          prop="storeNames"
        >
          <el-popover placement="bottom" width="460" trigger="click">
            <el-tree
              ref="tree"
              :data="storeList"
              :props="defaultProps"
              node-key="storeId"
              default-expand-all
              :default-checked-keys="selectedStoreIds"
              :show-checkbox="multiple"
              :check-strictly="true"
              @check-change="handleCheckChange"
            >
            </el-tree>
            <el-input
              v-model="ruleForm.storeNames"
              :label="$t('devices.inventory.No')"
              slot="reference"
              :placeholder="$t('devices.inventory.pleaseEnterStoreIds')"
              readonly
            ></el-input>
          </el-popover>
        </el-form-item>
      </el-col>
      <!-- {{ storeList }} -->
      <el-col :span="24">
        <el-form-item
          :label="$t('devices.inventory.Esls Type')"
          prop="tagTypeId"
        >
          <el-select
            v-model="ruleForm.tagTypeId"
            multiple
            clearable
            :placeholder="$t('devices.inventory.pleaseEnterEslType')"
            style="width: 460px"
          >
            <el-option
              v-for="item in tagTypeLists"
              :key="item.tagTypeCodeId" 
              :label="item.typeName"
              :value="item.tagTypeCodeId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.note')" prop="note">
          <el-input
            :maxlength="100"
            v-model="ruleForm.note"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-col>

      <!-- <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.Start Time')" prop="note">
          <el-radio label="立即开始"></el-radio>
          <el-radio label="定时开始"></el-radio>
          <el-input
            :maxlength="100"
            v-model="ruleForm.note"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-col> -->
    </el-row>
  </el-form>
</template>
<script>
import { getStoreList, getAllTagType } from "@/libs/api/inventory";
export default {
  props: {
    formData: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      allStoreIds: [],
      multiple: true,
      storeList: [
        {
          storeName: this.$t('devices.inventory.All'),
          storeId: 0,
          nextStoreList: [],
        },
      ],
      defaultProps: {
        label: "storeName",
        children: "nextStoreList",
      },
      selectedStoreIds: [], // 默认选中的key
      tagTypeLists: [], // 价签类型列表
      rules: {
        name: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterName"),
            trigger: "blur",
          },
        ],
        storeNames: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterStoreIds"),
            trigger: "change",
          },
        ],
        // tagTypeId: [
        //   {
        //     required: true,
        //     message: this.$t("devices.inventory.pleaseEnterEslType"),
        //     trigger: "change",
        //   },
        // ],
      },
      ruleForm: {
        name: '',
        storeIds: '',
        storeNames: '',
        tagTypeId: [],
        note: ''
      },
    };
  },
  watch: {},
  mounted() {
    this.getStore();
    this.getTagTypeList()
  },
  created() {
  },
  methods: {
    reset(){
      this.$refs.ruleForm.resetFields()
      this.$refs.ruleForm.clearValidate()
      this.ruleForm =  {
        name: '',
        storeIds: '',
        storeNames: '',
        tagTypeId: [],
        note: ''
      }
      this.$refs.tree.setCheckedKeys([]);
      this.selectedStoreIds = [] // 默认选中的key
       
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(this.allStoreIds)
      if (data.storeId == 0 && checked) {
        console.log(data.storeName);
        this.$refs.tree.setCheckedKeys([0, ...this.allStoreIds]);
      }
      if (data.storeId == 0 && !checked) {
        console.log("取消全选");
        // this.$refs.tree.setCheckedKeys([]);
      }
      // if (data.storeId != 0) {
      //   console.log("取消全选");
      //   this.$refs.tree.setCheckedKeys([]);
      // }
      // console.log(this.$refs.tree.getCheckedKeys());
      const selectData = this.$refs.tree.getCheckedKeys()
      const selectNodes = this.$refs.tree.getCheckedNodes()
      const nameLists = selectNodes.map(item => {
        return item.storeName
      })
      this.ruleForm.storeNames = nameLists.join(',')
      console.log(selectNodes)
      this.ruleForm.storeIds = []
      selectData.map(item => {
        this.ruleForm.storeIds.push(item)
      })
      // this.ruleForm.storeIds = this.$refs.tree.getCheckedKeys()
      console.log(data, checked, indeterminate);
    },
    getTagTypeList() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const params = {
        merchantId: userData.merchantId
      }
      getAllTagType(params).then(res => {
        console.log(res)
        this.tagTypeLists = res.data.data
      })
    },
    getStore() {
      let userData = JSON.parse(localStorage.getItem("userData"));
      const params = {
        storeId: userData.storeId,
        name: "",
      };
      getStoreList(params).then((res) => {
        this.allStoreIds = []
        console.log(res);
        this.storeList[0].nextStoreList = [res.data.data];
        const stores = [res.data.data]
        stores.map( item => {
          this.allStoreIds.push(item.storeId)
          if(item.nextStoreList && item.nextStoreList.length > 0){
            item.nextStoreList.map(n => {
              this.allStoreIds.push(n.storeId)
              if(n.nextStoreList && n.nextStoreList.length > 0){
                n.nextStoreList.map(subn => {
                  this.allStoreIds.push(subn.storeId)
                })
              }
            })
          }
        })
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
